export default "__VITE_ASSET__501ff84d__"